<template functional>
  <b-card
    no-body
    :border-variant="props.border"
  >
    <b-card-body>
      <b-row no-gutters>
        <b-col
          cols="8"
          class="px-2"
        >
          <b-row class="title-1">
            {{ props.name }}
          </b-row>
          <b-row>
            <h3>{{ props.value }} </h3>
          </b-row>
        </b-col>
        <b-col cols="4">
          <i
            :style="`color:${props.color}`"
            :class="`${props.arrow} fa-4x`"
            aria-hidden="true"
          />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  name: 'MetricCard',
  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    arrow: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: true
    },
    border: {
      type: String,
      default: 'light'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/shared/components/MetricCard.vue